import React__default from 'react';

var LobbyHeader = function (_a) {
    var _b = _a.iconName, iconName = _b === void 0 ? 'icon-info1' : _b, openHelpPopup = _a.openHelpPopup;
    return (React__default.createElement("div", { className: 'pgc-lobby-head' },
        React__default.createElement("i", { className: " ".concat(iconName), onClick: openHelpPopup })));
};

export { LobbyHeader };
